// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as UseApi$Showside from "./UseApi.bs.js";
import * as UseEnv$Showside from "./UseEnv.bs.js";
import * as Shopify$Showside from "../utils/Shopify.bs.js";
import * as LocalStorage$Showside from "../utils/LocalStorage.bs.js";
function useMarkets($$default, configId, enabledOpt, param) {
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  var match = UseEnv$Showside.use(undefined);
  var match$1 = UseApi$Showside.useMarkets(match.smartnavApiHost, enabled);
  var allMarkets = match$1.markets;
  var toString = function (value) {
    if (typeof value === "number") {
      return "U";
    } else if (value.TAG === /* Currency */0) {
      return "CU_" + value._0;
    } else {
      return "CO_" + value._0;
    }
  };
  var fromString = function (string) {
    if (string.startsWith("CU_")) {
      return {
        TAG: /* Currency */0,
        _0: string.replace(/^CU\_/, "")
      };
    } else if (string.startsWith("CO_")) {
      return {
        TAG: /* Country */1,
        _0: string.replace(/^CO\_/, "")
      };
    } else {
      return /* Unsupported */0;
    }
  };
  var defaultCountry = Belt_Option.map(Shopify$Showside.getCountry(undefined), function (country) {
    return {
      TAG: /* Country */1,
      _0: country
    };
  });
  var $$default$1 = Belt_Option.getWithDefault(Belt_Option.orElse($$default, defaultCountry), /* Unsupported */0);
  var match$2 = React.useState(function () {
    return Belt_Option.getWithDefault(Belt_Option.map(LocalStorage$Showside.get(undefined, {
      NAME: "selectedMarket",
      VAL: configId
    }), fromString), $$default$1);
  });
  var setMarket = match$2[1];
  var suggestedMarket;
  if (allMarkets !== undefined) {
    var match$3 = allMarkets.choices;
    suggestedMarket = match$3 !== undefined && typeof match$3 !== "number" ? match$3.TAG === /* Countries */0 ? {
      TAG: /* Country */1,
      _0: match$3._0.suggestedCountry
    } : {
      TAG: /* Currency */0,
      _0: match$3._0.suggestedCurrency
    } : undefined;
  } else {
    suggestedMarket = undefined;
  }
  React.useEffect(function () {
    Curry._1(setMarket, function (previous) {
      if (typeof previous === "number" && suggestedMarket !== undefined) {
        return suggestedMarket;
      } else {
        return previous;
      }
    });
  }, [suggestedMarket]);
  var handleMarketChange = React.useCallback(function (fn) {
    if (enabled) {
      return Curry._1(setMarket, function (previous) {
        var next = Curry._1(fn, previous);
        var __x = toString(next);
        LocalStorage$Showside.set(undefined, {
          NAME: "selectedMarket",
          VAL: configId
        }, __x);
        return next;
      });
    }
  }, [enabled, setMarket]);
  return [allMarkets, match$2[0], handleMarketChange];
}
export { useMarkets };
/* react Not a pure module */